









import ContactDetails from '@/components/common/contact-details/ContactDetails.vue'
import LocationMap from '@/components/common/location-map/LocationMap.vue'
import NavigationFooter from '@/components/common/navigation-footer/NavigationFooter.vue'
import NavigationHeader from '@/components/common/navigation-header/NavigationHeader.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    NavigationFooter,
    LocationMap,
    ContactDetails,
    NavigationHeader
  }
})
export default class App extends Vue {
}
